var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueUnlocked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M8.88888889,4.44444444 L8.25396825,4.44444444 L8.25396825,3.17460317 C8.25396825,1.42222222 6.83174603,1.33226763e-15 5.07936508,1.33226763e-15 C3.32698413,1.33226763e-15 1.9047619,1.42222222 1.9047619,3.17460317 L3.17460317,3.17460317 C3.17460317,2.12063492 4.02539683,1.26984127 5.07936508,1.26984127 C6.13333333,1.26984127 6.98412698,2.12063492 6.98412698,3.17460317 L6.98412698,4.44444444 L1.26984127,4.44444444 C0.571428571,4.44444444 8.8817842e-16,5.01587302 8.8817842e-16,5.71428571 L8.8817842e-16,12.0634921 C8.8817842e-16,12.7619048 0.571428571,13.3333333 1.26984127,13.3333333 L8.88888889,13.3333333 C9.58730159,13.3333333 10.1587302,12.7619048 10.1587302,12.0634921 L10.1587302,5.71428571 C10.1587302,5.01587302 9.58730159,4.44444444 8.88888889,4.44444444 Z M8.88888889,12.0634921 L1.26984127,12.0634921 L1.26984127,5.71428571 L8.88888889,5.71428571 L8.88888889,12.0634921 Z M5.07936508,10.1587302 C5.77777778,10.1587302 6.34920635,9.58730159 6.34920635,8.88888889 C6.34920635,8.19047619 5.77777778,7.61904762 5.07936508,7.61904762 C4.38095238,7.61904762 3.80952381,8.19047619 3.80952381,8.88888889 C3.80952381,9.58730159 4.38095238,10.1587302 5.07936508,10.1587302 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(5 3.333)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#005082",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#005082",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(-5 -3.333)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueUnlocked);
export default __webpack_public_path__ + "static/media/blue_unlocked.736f6a2f8a3248b48e0ef90a95bbdbd2.svg";
export { ForwardRef as ReactComponent };